module.exports = __webpack_public_path__ + "img/ice_pellets_heavy.5ee0972c.svg";